import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import "react-toastify/dist/ReactToastify.min.css";
import "semantic-ui-less/semantic.less";
import "./app/layout/styles.css";
import { Provider } from "react-redux";
import App from "./app/layout/App";
import * as serviceWorker from "./serviceWorker";
import ScrollToTop from "./app/layout/ScrollToTop";
import configureStore from "./app/store/configureStore";
import { Beforeunload } from "react-beforeunload";
import { removeToken } from "./app/config/auth/credentialConfiguration";

console.log("Prymera Digital is running on", process.env.REACT_APP_ENV);

const store = configureStore();

const history = createBrowserHistory();

// eslint-disable-next-line no-undef
const rootEl = document.getElementById("root");

const app = (
  <Provider store={store}>
    <Router history={history}>
      <ScrollToTop>
        <Beforeunload
        //onBeforeunload={() => removeToken()}
        >
          <App />
        </Beforeunload>
      </ScrollToTop>
    </Router>
  </Provider>
);

ReactDOM.render(app, rootEl);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

export default history;
